import { storageDateFormat } from '@/core';
import moment from 'moment';
export default function() {
	return {
		searchUUID: null,
		orders: [],
		ordersLoading: false,
		ordersFetching: false,
		searchFilter: {
			dateType: 'etd',
			date: {
				from: moment().startOf('day')
					.subtract(7,'d')
					.format(storageDateFormat),
				to:''
			},
			fromDespatchParty: [],
			toDeliveryParty: [],
			customer: [],
			goodsTypes: [],
			orderTypes: [],
			hasAta: { value: undefined, label: 'showAny' },
			hasAtd: { value: undefined, label: 'showAny' },
			economicalStatus: [],
			orderStatus: [],
			references: [],
			referencesText: '',
			waybillNumber: [],
			mustHaveInboundEdi: false,
			inboundEdi: '',
			mustHaveDeviation: false,
		},
		orderDetails: {},
		orderJsonId: null,
		loadedSearch: { id:-1, labelKey: 'resetSearch', },
		dateTypes: [
			'etd',
			'eta',
			'etx',
		],
		geocoding: false,
		totals: {
			orders: 0,
			volume: 0,
			weight: 0,
			loadingMeters: 0,
			totalPrice: 0,
			baseCurrency: 'NOK'
		},
	};
}
